/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  DepositDataHelper,
  DepositDataHelperInterface,
} from "../DepositDataHelper";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "bridgeAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "defaultMessageReceiver",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "ContractAddressNotWhitelisted",
    type: "error",
  },
  {
    inputs: [],
    name: "_bridgeAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_defaultMessageReceiver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_resourceIDToTokenContractAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_tokenContractAddressToTokenProperties",
    outputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "isWhitelisted",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isBurnable",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "isSet",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "externalDecimals",
            type: "uint8",
          },
        ],
        internalType: "struct ERCHandlerHelpers.Decimals",
        name: "decimals",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultDecimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "setBurnable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60c060405234801561001057600080fd5b506040516104f43803806104f483398101604081905261002f91610062565b6001600160a01b039182166080521660a052610095565b80516001600160a01b038116811461005d57600080fd5b919050565b6000806040838503121561007557600080fd5b61007e83610046565b915061008c60208401610046565b90509250929050565b60805160a0516104336100c1600039600061013401526000818161010d015261020701526104336000f3fe608060405234801561001057600080fd5b506004361061007d5760003560e01c806330f08abd1161005b57806330f08abd146100ee578063318c136e14610108578063a2f21f8a1461012f578063ac607c211461015657600080fd5b806307b7ed99146100825780630968f264146100975780630a6d55d8146100a8575b600080fd5b6100956100903660046102ed565b6101eb565b005b6100956100a5366004610333565b50565b6100d16100b63660046103e4565b6000602081905290815260409020546001600160a01b031681565b6040516001600160a01b0390911681526020015b60405180910390f35b6100f6601281565b60405160ff90911681526020016100e5565b6100d17f000000000000000000000000000000000000000000000000000000000000000081565b6100d17f000000000000000000000000000000000000000000000000000000000000000081565b6101b36101643660046102ed565b600160208181526000928352604092839020805492810154845180860190955260029091015460ff81811615158652610100918290048116938601939093529293828216939091049091169084565b6040805194855292151560208086019190915291151592840192909252815115156060840152015160ff16608082015260a0016100e5565b6101f36101fc565b6100a58161027b565b336001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016146102795760405162461bcd60e51b815260206004820152601e60248201527f73656e646572206d7573742062652062726964676520636f6e7472616374000060448201526064015b60405180910390fd5b565b6001600160a01b0381166000908152600160208190526040909120015460ff166102c3576040516325df77c560e11b81526001600160a01b0382166004820152602401610270565b6001600160a01b0316600090815260016020819052604090912001805461ff001916610100179055565b6000602082840312156102ff57600080fd5b81356001600160a01b038116811461031657600080fd5b9392505050565b634e487b7160e01b600052604160045260246000fd5b60006020828403121561034557600080fd5b813567ffffffffffffffff8082111561035d57600080fd5b818401915084601f83011261037157600080fd5b8135818111156103835761038361031d565b604051601f8201601f19908116603f011681019083821181831017156103ab576103ab61031d565b816040528281528760208487010111156103c457600080fd5b826020860160208301376000928101602001929092525095945050505050565b6000602082840312156103f657600080fd5b503591905056fea2646970667358221220fb645110e38f535be89ec7c4de0667451fd7e482cdb16501d52d5890705f937c64736f6c634300080b0033";

type DepositDataHelperConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: DepositDataHelperConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class DepositDataHelper__factory extends ContractFactory {
  constructor(...args: DepositDataHelperConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "DepositDataHelper";
  }

  deploy(
    bridgeAddress: string,
    defaultMessageReceiver: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DepositDataHelper> {
    return super.deploy(
      bridgeAddress,
      defaultMessageReceiver,
      overrides || {}
    ) as Promise<DepositDataHelper>;
  }
  getDeployTransaction(
    bridgeAddress: string,
    defaultMessageReceiver: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      bridgeAddress,
      defaultMessageReceiver,
      overrides || {}
    );
  }
  attach(address: string): DepositDataHelper {
    return super.attach(address) as DepositDataHelper;
  }
  connect(signer: Signer): DepositDataHelper__factory {
    return super.connect(signer) as DepositDataHelper__factory;
  }
  static readonly contractName: "DepositDataHelper";
  public readonly contractName: "DepositDataHelper";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DepositDataHelperInterface {
    return new utils.Interface(_abi) as DepositDataHelperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DepositDataHelper {
    return new Contract(address, _abi, signerOrProvider) as DepositDataHelper;
  }
}
